// @comfy/shared — 启动决策（幂等纯函数，可测）
// 依据 design.md「Property 5: 启动幂等且仅在需要时调用 StartInstances」与 Req 6.2。
/**
 * 依据当前 {@link PowerState} 计算启动决策，保证幂等：
 *
 * - `running`     → `{ running, false }`：实例已运行，**不**调用 StartInstances。
 * - `stopped`     → `{ starting, true }`：恰好调用一次 StartInstances，进入启动中。
 * - `starting`    → `{ starting, false }`：已在启动中，不重复触发。
 * - `stopping`    → `{ stopping, false }`：停机过渡态，不触发启动。
 * - `unavailable` → `{ unavailable, false }`：非可用态，不触发启动。
 *
 * 任何过渡态/非可用态都不会重复调用 `StartInstances`，从而满足幂等要求（Req 6.2）。
 *
 * @param state 当前实例的 PowerState（通常来自 `mapEc2State` 的结果）。
 * @returns 启动决策：下一状态与是否需要调用 StartInstances。
 */
export function decideStart(state) {
    switch (state) {
        case "running":
            return { nextState: "running", callStartInstances: false };
        case "stopped":
            return { nextState: "starting", callStartInstances: true };
        case "starting":
            return { nextState: "starting", callStartInstances: false };
        case "stopping":
            return { nextState: "stopping", callStartInstances: false };
        case "unavailable":
            return { nextState: "unavailable", callStartInstances: false };
    }
}
//# sourceMappingURL=startDecision.js.map